// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","264":"bc8efd0b","453":"d855a71b","455":"ec63873d","977":"4cfd06cb"}[chunkId] + ".chunk.js";
};